module.exports = __webpack_public_path__ + "assets/img/tdjl.010d5929.png";